/*
	Moment ships no locale with Levantine month/weekday names (شباط، آذار...) - only
	Modern Standard Arabic ones (فبراير، مارس...). Defining this locale once here lets
	every moment(...).format(...) call in the app pick up the Levantine names automatically
	as soon as i18n.js switches moment.locale('ar-lev') - see changeI18nLang.
*/
import moment from 'moment';
import { ARABIC_MONTHS, ARABIC_WEEKDAYS } from './constants';

const ARABIC_WEEKDAYS_SHORT = ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'];
const ARABIC_WEEKDAYS_MIN = ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'];

moment.defineLocale('ar-lev', {
	months: ARABIC_MONTHS,
	monthsShort: ARABIC_MONTHS,
	weekdays: ARABIC_WEEKDAYS,
	weekdaysShort: ARABIC_WEEKDAYS_SHORT,
	weekdaysMin: ARABIC_WEEKDAYS_MIN,
	// نفس بداية الأسبوع (السبت) المعتمدة للـ locale 'en' في main.js
	week: {
		dow: 6,
		doy: 12
	},
	longDateFormat: {
		LT: 'HH:mm',
		LTS: 'HH:mm:ss',
		L: 'DD/MM/YYYY',
		LL: 'D MMMM YYYY',
		LLL: 'D MMMM YYYY HH:mm',
		LLLL: 'dddd D MMMM YYYY HH:mm'
	}
});
